
import { takeEvery } from '@zaibot/fsa-saga';
import 'arrayq';

import { delay, fork, put, select } from '../redux-saga';
import { usergroupResource, usergroupEditor, usergroupBatch } from './resource';

import AUTHENTICATED from '../auth/actions/AUTHENTICATED';
import LOGGEDOUT from '../auth/actions/LOGGEDOUT';
import USERGROUP_LOADED from './actions/USERGROUP_LOADED';
import USERGROUP_NOT_LOADED from './actions/USERGROUP_NOT_LOADED';
import UPDATE_BUTTON_NO, { itemButtonTypeActionBewerkenUsergroup, itemButtonTypeActionDeleteItem, originAdmin } from '../focuslock/actions/UPDATE_BUTTON_NO';
import { INote, IUsergroup } from '../types';
import USERGROUP_UPDATED from './actions/USERGROUP_UPDATED';
import USERGROUP_CREATED from './actions/USERGROUP_CREATED';
import USERGROUP_REMOVE from './actions/USERGROUP_REMOVE';
import { isType } from '@zaibot/fsa';
import { notesEditor, notesResource } from '../note/notes/resource';
import { call, race, RaceEffect, take } from 'redux-saga/effects';

export function* rootSaga(): Iterable<any> {
    yield fork(usergroupResource.saga);
    yield fork(usergroupEditor.saga);
    yield fork(usergroupBatch.saga);
    yield fork(signalUserGroupWhenAuthenticated);
    yield fork(signalUserGroupReset);     
    yield fork(signalLoadAllUserGroupSuccess);
    yield fork(signalLoadAllUserGroupNotSuccess);
    yield fork(signalUserGroupUpdateSuccess);
    yield fork(signalUserGroupCreateSuccess);     
    yield fork(signalUserGroupRemove);        
}

function* signalLoadAllUserGroupSuccess() {
    yield takeEvery<any,any>([ usergroupResource.actions.LIST_SUCCESS, 
        ], function*(action){
            yield put(USERGROUP_LOADED({}));
    });
}

function* signalLoadAllUserGroupNotSuccess() {
    yield takeEvery<any,any>([ usergroupResource.actions.LIST_FAILURE, 
        ], function*(action){
            yield put(USERGROUP_NOT_LOADED({}));
    });
}

function* signalUserGroupCreateSuccess() {
    yield takeEvery<any,any>([ usergroupResource.actions.CREATE_SUCCESS, 
    ], function*(action){
        const usergr: IUsergroup = action.payload.item;
        yield put(USERGROUP_CREATED({usergroup: usergr}));
        yield put(usergroupResource.actions.LIST({}));
    });
}

function* signalUserGroupUpdateSuccess() {
    yield takeEvery<any,any>([ usergroupResource.actions.UPDATE_SUCCESS, 
    ], function*(action){
        const usergr: IUsergroup = action.payload.item;
        yield put(USERGROUP_UPDATED({usergroup: usergr}));
        yield put(usergroupResource.actions.LIST({}));
    });
}

function* signalUserGroupWhenAuthenticated() {
    yield takeEvery([AUTHENTICATED], 
                     function*(){
        yield put(usergroupResource.actions.LIST({}));
    });
}

function* signalUserGroupReset() {
    yield takeEvery(LOGGEDOUT, function*() {
        yield put(usergroupResource.actions.RESET({ }));
    });
}

function* signalUserGroupRemove() {
    const maxDelayTime = 10000;
    const minDelayTime = 1000;
    yield takeEvery(USERGROUP_REMOVE, function*(action){
        if (isType(action, USERGROUP_REMOVE)) {               
            var usergroup = action.payload.usergroup;
            const notes: INote[] = yield select(notesResource.selectors.items);
            var usergroupNotes = notes.qWhere((itm) => itm.noteParticipantGroupIDs ? itm.noteParticipantGroupIDs.map((x)=> typeof x === 'number'? x: parseInt(x)).qIncludes(usergroup.id): false);            
            var countNotesToUpdate = usergroupNotes.length;
            // To eliminate FK_... errors delete usergroups in notes.
            if (countNotesToUpdate>0) {
                try { 
                    for (var note of usergroupNotes) {
                        note.noteParticipantGroupIDs = note.noteParticipantGroupIDs.filter((id) => id===usergroup.id.toString()); 
                        yield put(notesEditor.actions.UPDATE_CONTINUE({item: note}));

                        const waiting: RaceEffect = yield race({
                            timeout: call(delay, maxDelayTime),
                            updateend: take([notesResource.actions.UPDATE_FAILURE, notesResource.actions.UPDATE_SUCCESS]),
                        });   
                        let waitresult: any = waiting;                
                        if (waitresult.updateend) {
                            if (countNotesToUpdate>0) {
                                countNotesToUpdate--;
                                if (countNotesToUpdate===0) {
                                    yield call(delay, minDelayTime),
                                    yield put(usergroupEditor.actions.DELETE_CONTINUE({ item: usergroup }));
                                }
                            }
                        }
                    }
                } catch (error) {
                    // tslint:disable-next-line                  
                    console.log(error);        
                }
            } else {
                yield put(usergroupEditor.actions.DELETE_CONTINUE({ item: usergroup }));
            }           
            
        }

    });
}



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/usergroup/sagas.tsx